import { createSlice } from '@reduxjs/toolkit';
import { getStorageItem, setStorageItem } from '../../utils/storage';

const VIDEO_DEVICE_ID_LABEL = 'compodium-preflight-video-device';
const MICROPHONE_DEVICE_ID_LABEL = 'compodium-preflight-microphone-device';
const SPEAKER_DEVICE_ID_LABEL = 'compodium-preflight-speaker-device';
const MUTED_LABEL = 'compodium-preflight-mute-microphone';
const HIDE_VIDEO_LABEL = 'compodium-preflight-hide-video';

export const deviceSlice = createSlice({
  name: 'device',
  initialState: {
    muted: getStorageItem(localStorage, MUTED_LABEL, false, true),
    hideVideo: getStorageItem(localStorage, HIDE_VIDEO_LABEL, false, true),
    videoinputDevices: [],
    audioinputDevices: [],
    audiooutputDevices: [],
    videoDeviceId: getStorageItem(localStorage, VIDEO_DEVICE_ID_LABEL, ''),
    microphoneDeviceId: getStorageItem(
      localStorage,
      MICROPHONE_DEVICE_ID_LABEL,
      ''
    ),
    speakerDeviceId: getStorageItem(localStorage, SPEAKER_DEVICE_ID_LABEL, ''),
  },
  reducers: {
    setVideoinputDevices: (state, action) => {
      state.videoinputDevices = action.payload.map((device) => ({
        deviceId: device.deviceId,
        groupId: device.groupId,
        label: device.label,
      }));
    },
    setAudioinputDevices: (state, action) => {
      state.audioinputDevices = action.payload.map((device) => ({
        deviceId: device.deviceId,
        groupId: device.groupId,
        label: device.label,
      }));
    },
    setAudiooutputDevices: (state, action) => {
      state.audiooutputDevices = action.payload.map((device) => ({
        deviceId: device.deviceId,
        groupId: device.groupId,
        label: device.label,
      }));
    },
    setVideoDeviceId: (state, action) => {
      state.videoDeviceId = action.payload;
      setStorageItem(localStorage, VIDEO_DEVICE_ID_LABEL, action.payload);
    },
    setMicrophoneDeviceId: (state, action) => {
      state.microphoneDeviceId = action.payload;
      setStorageItem(localStorage, MICROPHONE_DEVICE_ID_LABEL, action.payload);
    },
    setSpeakerDeviceId: (state, action) => {
      state.speakerDeviceId = action.payload;
      setStorageItem(localStorage, SPEAKER_DEVICE_ID_LABEL, action.payload);
    },
    toggleMicrophone: (state) => {
      state.muted = !state.muted;
      setStorageItem(localStorage, MUTED_LABEL, state.muted, true);
    },
    toggleVideo: (state) => {
      state.hideVideo = !state.hideVideo;
      setStorageItem(localStorage, HIDE_VIDEO_LABEL, state.hideVideo, true);
    },
  },
});

export const {
  setAudioinputDevices,
  setAudiooutputDevices,
  setVideoinputDevices,
  setMicrophoneDeviceId,
  setSpeakerDeviceId,
  setVideoDeviceId,
  toggleMicrophone,
  toggleVideo,
} = deviceSlice.actions;

export default deviceSlice.reducer;
